import { render, staticRenderFns } from "./NewThread.vue?vue&type=template&id=0b9affd9&scoped=true&"
import script from "./NewThread.vue?vue&type=script&lang=js&"
export * from "./NewThread.vue?vue&type=script&lang=js&"
import style0 from "./NewThread.vue?vue&type=style&index=0&id=0b9affd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9affd9",
  null
  
)

export default component.exports